// Vendors
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
// Contexts
import { useContractContextConsumerHook } from 'containers/contract/contexts/contract.context';
import { useLayoutContextConsumerHook } from 'components/layout/contexts/layout.context';
// Event Handlers
import { ContractErrorHandlers } from 'containers/contract/components/error/handlers/contract-error.handlers';

const useContractErrorHook = (): void => {
  const { formatMessage } = useIntl();

  const { setContractState } = useContractContextConsumerHook(),
    { setMainButtonConfiguration } = useLayoutContextConsumerHook();

  const { handleSetupContractErrorButtonConfiguration } = ContractErrorHandlers({
    formatMessage,
    setMainButtonConfiguration,
    setContractState,
  });

  useEffect(() => {
    handleSetupContractErrorButtonConfiguration();
  }, []);
};

export { useContractErrorHook };
